import { SHOW_SELECTED_URL_PARAM } from '@/constants/constants';
import { FILTER_KEYS } from '@/pages/Catalog/constants';

import type { FilterState } from '../types/filter';

export function getEmptyFilterState(): FilterState {
  return {
    only: null,
    [SHOW_SELECTED_URL_PARAM]: false,
    search: null,
    [FILTER_KEYS.COMMODITY]: null,
    [FILTER_KEYS.TRADING_HUB]: null,
    [FILTER_KEYS.DELIVERY_BASIS]: null,
    [FILTER_KEYS.PRICING_BASIS]: null,
    [FILTER_KEYS.UNITS]: null,
    [FILTER_KEYS.CURRENCY]: null,
    [FILTER_KEYS.FREQUENCY]: null,
    [FILTER_KEYS.INDEX_MODULE]: null
  };
}
